import { PostMissingDocsEmail } from 'domain/usecases/vendors/post-missing-docs-email';
import { BaseHttpService } from 'main/factories/http';

export class RemoteSendMissingDocsEmail
  extends BaseHttpService<PostMissingDocsEmail.Model>
  implements PostMissingDocsEmail
{
  async send(params: PostMissingDocsEmail.Params): Promise<PostMissingDocsEmail.Model> {
    return await this.request('post', params);
  }
}
